import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  drawerOpen: false,
  drawerType: "", // or "register"
  showSuccessToast: false, // optional
};

const authDrawerSlice = createSlice({
  name: "authDrawer",
  initialState,
  reducers: {
    openDrawer: (state, action) => {
      state.drawerOpen = true;
      state.drawerType = action.payload || "";
    },
    closeDrawer: (state) => {
      state.drawerOpen = false;
    },
    setDrawerType: (state, action) => {
      state.drawerType = action.payload;
    },
    setShowSuccessToast: (state, action) => {
      state.showSuccessToast = action.payload;
    },
  },
});

export const {
  openDrawer,
  closeDrawer,
  setDrawerType,
  setShowSuccessToast,
} = authDrawerSlice.actions;

export default authDrawerSlice.reducer;
